import React from "react";
import {Box, Container, IconButton, Typography, Stack, Divider} from "@mui/material";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function Footer() {
    const currentYear = new Date().getFullYear();

    const socialLinks = [
        {
            name: "GitHub",
            url: "https://github.com/PLR2388",
            icon: <GitHubIcon />,
            color: "#333"
        },
        {
            name: "LinkedIn",
            url: "https://www.linkedin.com/in/paul-louisrenard",
            icon: <LinkedInIcon />,
            color: "#0077b5"
        },
        {
            name: "Stack Overflow",
            url: "https://stackoverflow.com/users/8067131/paul",
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.36 20.2v-5.38h1.79V22H3.64v-7.18h1.8v5.38h12.92zM6.77 14.32l.37-1.76 8.79 1.85-.37 1.76-8.79-1.85zm1.16-4.21l.76-1.61 8.14 3.78-.76 1.62-8.14-3.79zm2.26-3.99l1.15-1.38 6.9 5.76-1.15 1.37-6.9-5.75zm4.45-4.25L20.96 8.3l-1.34 1.02-6.32-6.43 1.34-1.02zM6.59 18.04h9.01v1.79H6.59v-1.79z"/>
                </svg>
            ),
            color: "#f48024"
        }
    ];

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 4,
                px: 2,
                background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
                color: 'white',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                >
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        &copy; {currentYear} Paul-Louis Renard. All rights reserved.
                    </Typography>

                    <Stack direction="row" spacing={1}>
                        {socialLinks.map((link) => (
                            <IconButton
                                key={link.name}
                                component="a"
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={link.name}
                                sx={{
                                    color: 'white',
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                        transform: 'translateY(-3px)',
                                    }
                                }}
                            >
                                {link.icon}
                            </IconButton>
                        ))}
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}

export default Footer;